module.exports = __webpack_public_path__ + "static/media/success4_500x620.69e78d09.jpg";